import { Col, Row } from 'antd'
import React from 'react'
import Billingcard from '../../../../../components/dashboardpages/billingcard/billingcard'
import { studentPricing } from '../../../../../utils/data'

const Studentpricing = () => {
	return (
		<div>
			<p className='font-semibold text-appcolorblack text-[20px] leading-[28px] mb-10'>Billing</p>

			<div className='px-5 py-[1.3rem] bg-appcolorwhite'>
				<Row gutter={32}>
					{
						studentPricing.map((item, index) => (
							<Col lg={24} md={24} xs={24} key={`student-pricing-${index}`}>
								<Billingcard
									isActive={index === 0}
									item={item}
								/>
							</Col>
						))
					}

				</Row>
			</div>
		</div>
	)
}

export default Studentpricing